import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'

@vservice()
export class AdminContentItemChangeProfitUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  isSuccess = false

  isLoading = false

  execute(contentItemId: number, data: ProfitRequest) {
    return this.service.changeProfit(contentItemId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}